export const StructuralData = {
  img: require("../../images/Structural/Structural.webp"),
  alt: "Struktur Organisasi | PT ICONIQ MULTI DIMENSI",
  title: "Organizational Structure",
};
